import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

export const settingLabel = ($t, setting) => {
  if (messages[setting]) {
    return $t(messages[setting]);
  }
  return setting;
};

const SettingLabel = ({ setting }) => (messages[setting] ? <FormattedMessage {...messages[setting]} /> : setting || null);

export default SettingLabel;
